import { ReactElement } from "react";

import { FieldValues } from "react-hook-form";

import { BaseFormFieldProps, NonGenericBaseFormFieldProps } from "../../../common/types/baseFormField";

import { InputVibe } from "@/common/types/mui";

export interface BaseRadioGroupProps extends Omit<
  NonGenericBaseFormFieldProps,
  "control" | "rules" | "disableAutomcomplete"
> {
  canSearch?: boolean;
  className?: string;
  vibe?: InputVibe;
  defaultValue?: string;
  disabled?: boolean;
  onBlur?: () => void;
  onChange?: (value: string) => void;
  helperText?: NonGenericBaseFormFieldProps["label"];
  row?: boolean;
  searchPlaceholder?: string;
  size?: "medium" | "small";
  tooltipText?: string;
  values: Record<string, string | React.ReactElement<unknown>>;
  disabledValues?: Record<string, boolean>;
  fullWidth?: boolean;
  separator?: ReactElement<unknown> | string;
  alignContent?: "default" | "center";
  columns?: number;
  noAsterisk?: boolean;
  name?: string;
  tooltipTextValues?: Record<string, string>;
}

export interface FormRadioGroupProps<T extends FieldValues>
  extends Omit<BaseRadioGroupProps, "classes" | "name">, Omit<BaseFormFieldProps<T>, "disableAutomcomplete"> {}

export interface RadioGroupProps<T extends FieldValues> extends Omit<BaseRadioGroupProps, "classes"> {
  control?: BaseFormFieldProps<T>["control"];
  rules?: BaseFormFieldProps<T>["rules"];
  name?: BaseFormFieldProps<T>["name"];
}

export enum BannerFormat {
  Image = "image",
  Video = "video",
}
